export default __webpack_public_path__ + "static/media/cardBanner.594574fd.png";